// @flow strict
import * as React from 'react';

const CheckMark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="23">
    <path d="M24.916 0L9.7 16.52 3.023 9.765 0 13.066 9.752 23 28 3.241z" fill="#0CB14B" />
  </svg>
);

export { CheckMark };
